// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import { capitalizeFLetter, fetchApiData } from '../../../fnc.js'
import { error } from "jquery";

const refConst = require("../../../constants.js").v

export default function ModalTicket(props){

	const initialState = {
		stores: [],
		selectedStoreToAssigne: [],
		modalSearchTerm: "",
		version: "0.1.0"
	}

	const refModalAssignedTo = useRef(null);
	const [selectedStoreToAssigne, setSelectedStoreToAssigne] = useState(initialState.selectedStoreToAssigne);
	const [modalSearchTerm, setModalSearchTerm] = useState(initialState.modalSearchTerm);
	const [stores, setStores] = useState(initialState.stores);
	const [version, setVersion] = useState(initialState.version);

	useEffect(() => {
		if(refModalAssignedTo.current)
			modalAssignedTo(refModalAssignedTo.current)
	}, [props.accounts, refModalAssignedTo?.current, selectedStoreToAssigne, modalSearchTerm, refConst.stores, stores])

	let findEmailFromId = (id) => {
		let store = stores.find(s => s.id === id)
		return store?.title ?? "-"
	}

	let init = () => {
		resetPage()
		fetchStores()
		fetchAssignedStores()
		modalAssignedTo(props.pma)
	}

	let fetchStores = () => {
		fetchApiData("eio", "getPMAStores", {}, null, (r) => {
			console.log("getPMAStores", r)
			setStores(r.data?? [])
		})
	}

	let fetchAssignedStores = () => {
		fetchApiData("eio", "getPMAStoresAssociated", {
			filters: JSON.stringify({
				'id_pma': props.pma.id
			})
		}, null, (r) => {
			console.log("getPMAStoresAssociated", r)
			if(r.error){
				props.info({error: r.error})
			}else{
				setSelectedStoreToAssigne(r.data.map(v => parseInt(v.id_pma_stores)))
			}
		})
	}

	let submitMainData = () => {
		let stAss = []
		selectedStoreToAssigne.forEach(id => {
			if(id && props.pma.id)
				stAss.push({
					'id_pma': props.pma.id,
					'id_pma_stores': id,
				})
		})
		fetchApiData("eio", "setPMAStoreAssociated", {
			'id_pma': props.pma.id, // necessary in case we remove all of it
			'data': JSON.stringify(stAss)
		}, null, (r) => {
			console.log("setPMAStoreAssociated", r)
			if(r.errors){
				props.info({error: JSON.stringify(r.errors)})
			}else{
				props.getPmaList()
			}
		})
	}

	let modalAssignedTo = (pma) => {
		// Reset modal search when opening modal
		console.log("selectedStoreToAssigne2", selectedStoreToAssigne)

		props.modal({
			show: true,
			title: "Competitor Assignement",
			html: () => {
				return <div>
					{
						selectedStoreToAssigne.length > 0?
							<div className="alert alert-info">
								Selected stores {selectedStoreToAssigne.length} stores:
								<ul>
									{selectedStoreToAssigne.map(id => {
										return <li key={`${id}-storeList`}>{findEmailFromId(id)}</li>
									})}
								</ul>
							</div> : ""
					}
					<div className="mb-3">
						<input
							type="text"
							className="form-control"
							placeholder="Search users..."
							value={modalSearchTerm}
							onChange={(e) => setModalSearchTerm(e.target.value)}
						/>
					</div>
					<div className="list-group" style={{maxHeight: "300px", overflowY: "auto"}} >
						{
							stores? stores.filter(s => {
								if(modalSearchTerm.length > 0){
									return s.title.toLowerCase().includes(modalSearchTerm.toLowerCase());
								}
								return true
							})
							.map((s, pos) => {
								return (
									<button 
										key={`${pos}-${s.title}-main`}
										type="button" 
										className={"list-group-item list-group-item-action d-flex justify-content-between align-items-center" + (selectedStoreToAssigne.indexOf(s.id) !==  -1? " active" : "")}
										onClick={() => {
											
											setSelectedStoreToAssigne(prevSelected => {
												const idx = prevSelected.indexOf(s.id);
												if (idx === -1) {
													return [...prevSelected, s.id];
												} else {
													return prevSelected.filter(id => id !== s.id);
												}
											});
										}}
									>
										{s.title}
									</button>
								)
							}) : ""}
					</div>
				</div>
			}
			,ok: {
				title: "Save",
				fnc: (popup, close) => {
					submitMainData()
					close()
				}
			},
			exit: (popup, close) => {
				refModalAssignedTo.current = false
				close()
			},
			return: {
				title: "Close",
				fnc: (popup, close) => {
					refModalAssignedTo.current = false
					close()
				}
			}
		})
	}

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				// const element = initialState[key];
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}

	return (
		<div className={"pointer" + ("className" in props? props.className : ' list-group-item list-group-item-action p-2 text-center')} onClick={() => {
			refModalAssignedTo.current = props.pma
			init()
		}}>
			{
				props.title
			}
		</div>
	);
}